import script from "./CoursePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./CoursePicker.vue?vue&type=script&setup=true&lang=js"

import "./CoursePicker.vue?vue&type=style&index=0&id=5597e442&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5597e442"]])

export default __exports__